<template>
  <router-link :to="to"
  class="bg-white text-white py-2 px-4 rounded items-center"
  :class="[
    {'shadow' : isDefault},
    {'hover:bg-gray-100' : isDefault},
    {'text-support-300' : isDefault},
    {'border-gray-400' : isDefault},
    {'border' : isDefault},
    {'border-b-4' : is3D},
    {'border-secondary-700' : color == 'secondary'},
    {'bg-secondary-500' : color == 'secondary'},
    {'hover:border-secondary-500' : color == 'secondary'},
    {'hover:bg-secondary-300' : color == 'secondary'},
    {'inline-flex' : icon},
    {'w-full': isMobile},
    {'block': isMobile},
  ]"
  >

  <svg  v-if="icon == 'download'" class="fill-current w-4 h-4" :class="[{'ml-2': isRtl},{'mr-2': !isRtl}]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z"/></svg>
  <span>
    <slot></slot>
  </span>
</router-link>

</template>

<script>
import {mapGetters} from 'vuex';

export default {
    props: ['to', 'type', 'color', 'icon', 'is-mobile'],
    name: 'Btn',
    computed: {
        isDefault() {
            return this.type == 'default';
        },
        is3D() {
            return this.type == '3d';
        },
        ...mapGetters({
          isRtl: ['locale/IS_RTL']
        })
    }
}
</script>

<style>

</style>
